import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  icon?: BoxIcon;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  icon: Icon,
  fullWidth = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'flex items-center justify-center gap-2 rounded-2xl py-4 px-6 font-semibold text-base transition-colors min-h-[56px]';
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm',
    secondary: 'bg-blue-50 text-blue-700 hover:bg-blue-100',
    outline: 'bg-white text-blue-600 border-2 border-blue-100 hover:border-blue-200 hover:bg-slate-50'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: 0.97
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-31">
      {Icon && <Icon size={20} className={variant === 'primary' ? 'text-white' : 'text-blue-600'} data-id="element-32" />}
      {children}
    </motion.button>;
}